module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Italian Prince, Wedlocked Wife")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "application/xhtml+xml; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cov"
    }
  }, [_c('svg:svg', {
    attrs: {
      "height": "100%",
      "viewbox": "0 0 600 800",
      "width": "100%"
    }
  }, [_c('svg:image', {
    attrs: {
      "height": "800",
      "transform": "translate(0 0)",
      "width": "600",
      "xlink:href": "Images/MSRCover.jpg"
    }
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3380dce9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/italianprincewedlockedwife_cov.vue
// module id = 54
// module chunks = 0